import {
  EnqueteAdapterInteface,
  ListEnquetesInput,
} from 'src/adapter/EnqueteAdapterInterface';
import {
  EnqueteSendAttributes,
  EnqueteGetAttributes,
} from 'src/models/EnqueteModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosEnqueteAdapter implements EnqueteAdapterInteface {
  async listEnquetes(
    conditions?: ListEnquetesInput
  ): Promise<{ total: number; data: EnqueteGetAttributes[] }> {
    try {
      const res = await api.get('/enquetes', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getEnquete(id: string): Promise<EnqueteGetAttributes> {
    try {
      const res = await api.get(`/enquetes/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createEnquete(
    attributes: EnqueteSendAttributes
  ): Promise<EnqueteGetAttributes> {
    try {
      const res = await api.post('/enquetes', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateEnquete(
    id: string,
    attributes: EnqueteSendAttributes
  ): Promise<EnqueteGetAttributes> {
    try {
      const res = await api.put(`/enquetes/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteEnquete(id: string): Promise<boolean> {
    try {
      return await api.delete(`/enquetes/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async start(id: string): Promise<boolean> {
    try {
      return await api.put(`/enquetes/${id}/start`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async finish(id: string): Promise<boolean> {
    try {
      return await api.put(`/enquetes/${id}/finish`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
